<template>
  <div id="fd-app">
    <div class="container">
      <v-data-table
        :headers="headers"
        :items="fdStats"
        item-key="co_code"
        hide-default-footer
        :class="['frozen-header-table', 'custom-scrollable-table']"
        :mobile-breakpoint="0"
        :items-per-page="-1" loading-text="Loading..." loading
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="sticky-column">{{ item.co_name }}</td>
            <td style="text-align: center;">{{ item.deposit_size }}</td>
            <td style="text-align: center;">{{ item.crar3 }}</td>
            <td style="text-align: center;">{{ formatPercent(item.pgnpa) }}</td>
            <td style="text-align: center;">{{ formatPercent(item.pnnpa) }}</td>
            <td style="text-align: center;">{{ item.systemic_important }}</td>
            <td style="text-align: center;">{{ item.under_pca }}</td>
            <td style="text-align: center;">{{ item.prime_confidence_level }}</td>
          </tr>
        </template>
      </v-data-table>
      
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'BankFd',
  data() {
    return {
      headers: [
        { text: 'Bank name', value: 'co_name', width: '200px', fixed: 'left', align: 'center', class: 'white-text-header' },
        { text: 'Deposit size (in Rs. Crore)', value: 'deposit_size', width: '200px', align: 'center', class: 'white-text-header' },
        { text: 'Capital adequacy', value: 'crar3', width: '180px', align: 'center', class: 'white-text-header' },
        { text: 'GNPA (%)', value: 'pgnpa', width: '130px', align: 'center', class: 'white-text-header' },
        { text: 'NNPA (%)', value: 'pnnpa', width: '130px', align: 'center', class: 'white-text-header' },
        { text: 'Systemically important?', width: '180px', align: 'center', value: 'systemic_important', class: 'white-text-header' },
        { text: 'Under PCA?', value: 'under_pca', width: '150px', align: 'center', class: 'white-text-header' },
        { text: 'Prime confidence', value: 'prime_confidence_level', width: '150px', align: 'center', class: 'white-text-header' }
      ],
      fdStats: []
    };
  },
  created() {
    this.fetchFdStats();
  },
  methods: {
     fetchFdStats() {
    const action = 'get_fd_vue_stats';
    const url = this.getUrl(action);

     axios.get(url)
        .then(response => {
          console.log(response);
          this.fdStats = response.data;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
  },
  getUrl(action) {
      return `${process.env.VUE_APP_API_DOMAIN}/wp-admin/admin-ajax.php?action=${action}`;
    },
    formatPercent(value) {
      if (!value || value === '') {
        return 'NA';
      }
      const formattedPercent = parseFloat(value).toFixed(2);
      return `${formattedPercent} %`;
    }
  }
};
</script>

<style>
.frozen-header-table th:first-child,
.frozen-header-table {
  position: sticky;
  left: 0;
  z-index: 1;
}

.custom-scrollable-table .v-data-table-header {
  position: sticky;
  top: 0;
  z-index: 1;
}

.custom-scrollable-table th {
  background-color: #708090;
  font-size: 16px;
}

.custom-scrollable-table .v-data-table__wrapper {
  max-height: 700px;
  overflow-y: auto;
}

.v-data-table-header__icon.mdi.mdi-arrow-up.theme--light,
.v-data-table-header__icon.mdi.mdi-arrow-down.theme--light {
  display: none;
}

.v-data-table-header th.active {
  color: #dc4b00 !important;
}

.sticky-column {
  position: sticky;
  left: 0;
  background-color: #c0c0c0;
}

.white-text-header {
  color: white !important;
  font-family: 'Lato', sans-serif;
  font-size: 16px !important;
}

.text-center.white-text-header.sortable {
  padding: 7px;
}

.no-data-cell {
   display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  text-align: center;
  vertical-align: middle;
}
</style>
